import NextImage from "next/image"
import Breadcrumbs from "components/Breadcrumbs"
import richText from "utilities/richText"

export default function GradientPageHeader({ blok }) {
  return (
    <header className="relative flex flex-col md:flex-row md:justify-end bg-primary">
      <NextImage
        alt=""
        src="/assets/blue-weave-crop.webp"
        quality={80}
        placeholder="blur"
        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mMUUvGoBwABzQD/+RWwWwAAAABJRU5ErkJggg=="
        fill
        sizes="100vw"
        style={{
          objectFit: "cover",
        }}
        priority
        aria-hidden
      />

      <div className="md:py-0 md:absolute md:left-1/2  md:max-w-screen-xl md:top-1/2 w-full mx-auto md:-translate-x-1/2 md:-translate-y-1/2">
        <div className="px-5 py-7 max-w-xl relative">
          <Breadcrumbs breadcrumbs={blok?.breadcrumbs} />
          <h1 className="text-white text-l2 xl:text-xl2 py-2 capitalize">{blok.heading}</h1>
          {blok.subheading && <h3 className="text-white py-3">{blok.subheading}</h3>}
          {blok.content && <div className="text-white prose max-w-2xl">{richText(blok.content)}</div>}
        </div>
      </div>

      <NextImage
        alt=""
        src={blok?.image?.filename}
        quality={80}
        placeholder="blur"
        blurDataURL={blok?.image?.blurDataURL}
        className="image-gradient-mask md:max-w-[50%] xl:max-w-[800px]"
        sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw"
        style={{
          maxHeight: "700px",
          width: "100%",
          height: "auto",
          objectFit: "cover",
        }}
        height="483"
        width="800"
      />
    </header>
  )
}
